import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=45984641&scoped=true"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"
import style0 from "./statement.vue?vue&type=style&index=0&id=45984641&prod&lang=scss&scoped=true"
import style1 from "./statement.vue?vue&type=style&index=1&id=45984641&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45984641",
  null
  
)

export default component.exports